import { SearchMode } from './context'

export const SEARCH_HEIGHT = 40
export const MARGIN = 10

export const getAppWidth = (columns: number, gifWidth: number) => columns * (gifWidth + MARGIN) + MARGIN
export type AppConfig = {
    width: number
    height: number
    isBrowserExtension: boolean
    columns: number
    flexVertical?: boolean
}

export const Small: AppConfig = {
    width: getAppWidth(2, 145),
    height: 485,
    isBrowserExtension: false,
    columns: 2,
}

export const Large: AppConfig = {
    width: getAppWidth(2, 152),
    height: 600,
    isBrowserExtension: true,
    columns: 2,
}

export const placeholderCopy: { [key in SearchMode]: string } = {
    gifs: 'GIFs',
    stickers: 'Stickers',
    emoji: 'Emojis',
    text: 'Text',
    videos: 'Clips',
}
